import RingHeader from '@jetbrains/ring-ui/components/header/header'
import classNames from 'classnames'
import * as React from 'react'

import {PlaceIdList} from '../../../plugins/plugins.types'
import {noop} from '../../../utils/empty'
import Plugin from '../../common/Plugin/Plugin'

import HeaderTray from './Header.tray'
import {getTopNavHelperData} from './Header.utils'
import HeaderLinks from './Links/Links'

import styles from './Header.css'

export type HeaderProps = {
  adminSpaceAvailable?: boolean
  onRender?: () => unknown
}

function Header({
  adminSpaceAvailable = getTopNavHelperData().adminSpaceAvailable,
  onRender = noop,
}: HeaderProps) {
  React.useEffect(() => {
    onRender()
  }, [onRender])

  return (
    <>
      <RingHeader className={classNames('sakura-header', styles.container)}>
        <HeaderLinks />
        <Plugin inline placeId={PlaceIdList.SAKURA_HEADER_NAVIGATION_AFTER} />
        <HeaderTray adminSpaceAvailable={adminSpaceAvailable} />
      </RingHeader>
    </>
  )
}

export default React.memo(Header)
